import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonAdvancedModule } from '@app/common/advanced/common.advanced.module';
import { CommonBasicModule } from '@app/common/basic/common.basic.module';
import { CoreModule } from '@app/core/core.module';
import { RootContainerComponent } from '@app/root/containers/root-container/root-container.component';
import { RootRoutingModule } from '@app/root/root-routing.module';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { I18NextModule } from 'angular-i18next';

const isProd = process.env.NODE_ENV === 'production';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,

    // init i18next module
    I18NextModule.forRoot(),

    // init NGXS module
    // no root state here, all feature states will be imported in feature modules
    NgxsModule.forRoot([], { developmentMode: !isProd }),
    NgxsStoragePluginModule.forRoot({ key: ['core'] }),
    NgxsRouterPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: isProd }),

    // import common components module
    // use forRoot() instead of import it directly
    // https://medium.com/@michelestieven/organizing-angular-applications-f0510761d65a
    CommonBasicModule.forRoot(),
    CommonAdvancedModule.forRoot(),

    // core module should be always be injected in root module
    CoreModule.forRoot(),

    // don't import feature modules here,
    // all feature modules will be loaded asynchronously
    // check root-routing.module.ts
    RootRoutingModule,
  ],
  exports: [],
  declarations: [RootContainerComponent],
  providers: [{ provide: LOCALE_ID, useValue: 'en-US' }],
  bootstrap: [RootContainerComponent],
})
export class RootModule {}
